import { repApi, qs } from './repApi';
import type { Group } from '@/types';

export const groupsApi = repApi.injectEndpoints({
  endpoints: (builder) => ({
    listGroups: builder.query<Group[], void>({
      query: () => '/groups',
      keepUnusedDataFor: 600,
      providesTags: ['Groups'],
    }),
    /** The 20 REP counties with the count of letters past Incomplete (for one year). */
    repCounties: builder.query<Group[], { year?: string | number } | void>({
      query: (arg) => `/groups/counties${qs({ year: arg ? arg.year : undefined })}`,
      providesTags: ['Groups', 'Lcert'],
    }),
    getGroup: builder.query<Group, number>({
      query: (id) => `/groups/${id}`,
      keepUnusedDataFor: 600,
    }),
  }),
});

export const { useListGroupsQuery, useRepCountiesQuery, useGetGroupQuery } = groupsApi;
